import React, { Fragment } from 'react';
import { shape, string } from 'prop-types';

const Result = ( result ) => {

    const resultData = result.attributes;

    function getSpacing( index ) {

        if ( index === 0 ) {

            return <span className="lesson-author-by">by </span>;

        }
        else if ( index === resultData.authors.length - 1 ) {

            return '\u00A0\u0026 ';

        }
        else {

            return ', ';

        }

    }

    function getAuthors() {

        if ( resultData.authors ) {

            return (
                <Fragment>

                    <ul>

                        { resultData.authors.map( ( { name, url }, index ) => (

                            <li key={ name } className="author">
                                { getSpacing( index ) }
                                { url ? <a href={ url }>{ name }</a> : <span>{ name }</span> }
                            </li>

                        ) ) }

                    </ul>

                    { resultData.level && <span className="grade-with-author">{ resultData.level }</span> }

                </Fragment>

            );

        }

        else if ( resultData.level ) {

            return <span className="grade">{ resultData.level }</span>;

        }

    }

    return (
        <div className="lesson-plan-result">

            <div className="lesson-plan-img-info">

                { resultData.image
                  && <img className="lesson-plan-img" src={ resultData.image.url } alt={ resultData.image.alt } />}

            </div>

            <div className="lesson-plan-desc">

                <p className={ `icon-type-label icon-type-${ result.normalizedType } result-type` }>{ result.type }</p>

                <h2><a href={ resultData.url } target="_blank" rel="noopener noreferrer">{ resultData.title }</a></h2>

                <div className="author-section">

                    { getAuthors() }

                </div>

                { resultData.excerpt
                  && <p className="excerpt" dangerouslySetInnerHTML={ { __html: resultData.excerpt } }></p>}

            </div>
        </div>
    );

};

Result.propTypes = {
    type: string,
    normalizedType: string,
    id: string,
    attributes: shape( {
        title: string,
        displayMonth: string,
        level: string,
        excerpt: string,
    } ),
    authors: shape( {
        name: string,
    } ),
};

export default Result;
